import { jwtDecode } from "jwt-decode";
import { useNuxtApp } from "nuxt/app";
import { useAuthState } from "../states/auth.js";
import { gqlMutation } from "./gql-mutation.js";
let inProgress = false;
let progressResult;
export function useAuth() {
  async function requestNewToken() {
    if (inProgress) {
      while (!progressResult) {
        await new Promise((resolve) => setTimeout(resolve, 10));
      }
      return progressResult;
    }
    [inProgress, progressResult] = [true, null];
    const { data } = await gqlMutation("refreshToken", { disableTokenCheck: true, fields: ["token", "refreshToken"] });
    if (data) {
      setTokens(data.token, data.refreshToken);
    } else {
      return null;
    }
    const result = {
      refreshToken: data.refreshToken,
      token: data.token
    };
    [inProgress, progressResult] = [false, result];
    return result;
  }
  async function checkTokenAndRenew() {
    const { accessTokenState } = useAuthState();
    if (isTokenExpired(accessTokenState.value)) {
      await requestNewToken();
    }
  }
  function setTokens(newToken, newRefreshToken) {
    const { accessTokenState, refreshTokenState } = useAuthState();
    const { $setAuthCookies } = useNuxtApp();
    accessTokenState.value = newToken;
    refreshTokenState.value = newRefreshToken;
    $setAuthCookies(newToken, newRefreshToken);
  }
  function setCurrentUser(user) {
    const { currentUserState } = useAuthState();
    currentUserState.value = user;
  }
  function signIn(input) {
    const { accessTokenState, currentUserState, refreshTokenState } = useAuthState();
    const { $setAuthCookies } = useNuxtApp();
    accessTokenState.value = input.token;
    refreshTokenState.value = input.refreshToken;
    currentUserState.value = input.user;
    $setAuthCookies(input.token, input.refreshToken);
  }
  function clearSession() {
    const { accessTokenState, currentUserState, refreshTokenState } = useAuthState();
    const { $setAuthCookies } = useNuxtApp();
    accessTokenState.value = null;
    refreshTokenState.value = null;
    currentUserState.value = null;
    $setAuthCookies(null, null);
  }
  function getDecodedAccessToken(token) {
    if (!token) {
      return null;
    }
    try {
      return jwtDecode(token);
    } catch (err) {
      return null;
    }
  }
  function isTokenExpired(token) {
    if (token) {
      const decoded = getDecodedAccessToken(token);
      return decoded?.exp < Date.now() / 1e3;
    }
    return false;
  }
  return {
    checkTokenAndRenew,
    clearSession,
    getDecodedAccessToken,
    isTokenExpired,
    requestNewToken,
    setCurrentUser,
    setTokens,
    signIn
  };
}
